export default __webpack_public_path__ + "static/media/bplan.09d8d26f.svg";